<template>
  <div class="component-wrapper d-flex flex-column">
    <Header />

    <div class="local elevation-5 rounded white" ref="local">
      <div
        class="track-msg white--text body-1 text-center"
        v-if="tracksMuted.video"
      >
        Η κάμερά σας είναι απενεργοποιημένη
      </div>

      <div
        class="track-msg body-2 warning--text text-center"
        v-if="Boolean(cameraError)"
      >
        {{ cameraError }}
      </div>
    </div>

    <div class="remote" ref="remote">
      <div class="track-msg body-1 text-center" v-if="!remoteConnected">
        
          <!-- Μουσείο Κοτσανά -->
        <div
          v-if="program && program.museum.museumLocales[0].title === 'Μουσείο Κοτσανά'"
          class="museum-image-wrapper"
        >
          <img class="museum-image" :src="require('../assets/leo.jpg')" />
        </div>

          <!-- Αν δεν είναι κανένα από τα παραπάνω -->
        <div v-else>
            Ο υπεύθυνος του προγράμματος δεν έχει συνδεθεί. Παρακαλούμε περιμένετε!
        </div>
      </div>

      <div
        class="track-msg black body-1 text-center white--text"
        v-if="!remoteVideoState && remoteConnected"
      >

        <!-- Μουσείο Κοτσανά -->
        <div
          v-if="program && program.museum.museumLocales[0].title === 'Μουσείο Κοτσανά'"
          class="museum-image-wrapper"
        >
          <img class="museum-image" :src="require('../assets/leo.jpg')" />
        </div>

          <!-- Αν δεν είναι κανένα από τα παραπάνω -->
        <div v-else>
              Ο υπεύθυνος του προγράμματος έχει κλείσει προσωρινά την κάμερα του
        </div>
      </div>
    </div>

    <Buttons />
  </div>
</template>

<script>
import Header from "@/views/Header";
import Buttons from "@/views/Buttons";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  components: {
    Header,
    Buttons,
  },
  computed: {
    ...mapState({
      triggersetListeners: (state) => state.twilio.triggersetListeners,
      remoteConnected: (state) => state.twilio.remoteConnected,
      remoteVideoState: (state) => state.twilio.remoteVideoState,
      tracksMuted: (state) => state.twilio.tracksMuted,
      allowLeave: (state) => state.school.allowLeave,
      cameraError: (state) => state.twilio.cameraError,
      program: (state) => state.school.program
    }),
  },
  mounted() {
    this.changeRefs({
      local: this.$refs.local,
      remote: this.$refs.remote,
    });

    if (!this.triggersetListeners) this.setTriggersetListeners();
  },
  methods: {
    ...mapActions(["changeRefs", "detachTracks"]),
    ...mapMutations(["setTriggersetListeners", "setAllowLeave"]),
  },
  destroyed() {
    this.detachTracks();
  },
  beforeRouteLeave(to, from, next) {
    if (this.allowLeave) {
      this.setAllowLeave(false);
      next();
    } else {
      next(false);
    }
  },
};
</script>

<style lang="scss" scoped>
.local {
  position: absolute;
  top: calc(53px + 20px); //53px is the header height.
  left: 16px;
  width: 160px;
  height: 120px;
  z-index: 1;
  overflow: hidden;
}

.remote {
  height: 1px;
  flex-grow: 1;
}

.museum-image-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.museum-image {
  max-width: 100%;
  max-height: 65%;
  object-fit: contain;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
}

</style>